import './style.scss'

import { Route, Switch } from 'react-router-dom'

import OldCMView from './OldCMView'
import OldCategoriesView from './OldCategoriesView/OldCategoriesView'
import OldDelegateView from './OldDelegateView'
import OldPlayersView from './OldPlayersView'
import OldTeamView from './OldTeamView'
import OldTeamsView from './OldTeamsView'
import React from 'react'

const OldCMApp = () => {
  return (
    <Switch>
      <Route exact path="/cm/">
        <OldCMView />
      </Route>
      <Route path="/cm/categories">
        <OldCategoriesView />
      </Route>
      <Route exact path="/cm/delegate">
        <OldDelegateView />
      </Route>
      <Route exact path="/cm/teams">
        <OldTeamsView />
      </Route>
      <Route path="/cm/teams/:teamId">
        <OldTeamView />
      </Route>
      <Route exact path="/cm/players">
        <OldPlayersView />
      </Route>
    </Switch>
  )
}

export default OldCMApp